import { render, staticRenderFns } from "./SnagComponent.vue?vue&type=template&id=58735cbc&scoped=true&"
import script from "./SnagComponent.vue?vue&type=script&lang=js&"
export * from "./SnagComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58735cbc",
  null
  
)

export default component.exports